import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Line } from "react-chartjs-2";
import ZoomControls from "../UI/ChartZoomControls";
import { useTheme } from "@emotion/react";
import BoxCharts from "../UI/BoxCharts";

function ScopeDamageIndex({
  indice_danno,
  dateLabels,
  zoomOptions,
  chartRef,
  onResetZoom,
  onZoomPluse,
  onZoomMinus,
  onPanPluse,
  onPanMinus,
}) {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const theme = useTheme();

  const Scope_Damage_Index_config = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: theme.palette.white.main,
        }
      },
      title: {
        display: true,
        text: "Scope Damage Index",
        color: theme.palette.white.main,
      },
      zoom: zoomOptions,
    },
    scales:{
      x:{
        ticks:{
          color: theme.palette.white.main,
        }
      },
      y:{
        ticks:{
          color: theme.palette.white.main,
        }
      }
    }
  };
  // const Scope_Damage_Index_chart_data = {
  //   labels: dateLabels,
  //   datasets: [
  //     {
  //       label: "Indici di Danno",
  //       data: indice_danno,
  //       borderColor: "rgba(75, 192, 192, 1)",
  //       backgroundColor: "rgba(75, 192, 192, 0.2)",
  //     },
  //   ],
  // };


  useEffect(() => {
    setChartData({
      labels: dateLabels,
      datasets: [
        {
          label: indice_danno.length ? "Indici di Danno" : "",
          data: indice_danno,
          borderColor: indice_danno.length ? "rgba(75, 192, 192, 1)" : "rgba(0,0,0,0)",
          backgroundColor: indice_danno.length ? "rgba(75, 192, 192, 0.2)" : "rgba(0,0,0,0)",
        },
      ],
    });
  }, [indice_danno, dateLabels]);

  return (
    <>
      <BoxCharts minHeight="380px" maxHeight="700px" >
        <Box sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
          padding: 3
        }} >
          <Typography variant='h5' color="text.secondary" fontWeight={600} >Indici danni di Ambito</Typography>
          <ZoomControls
            onResetZoom={onResetZoom}
            onZoomPluse={onZoomPluse}
            onZoomMinus={onZoomMinus}
            onPanPluse={onPanPluse}
            onPanMinus={onPanMinus}
          />
        </Box>

        <Line
          height={'100%'}
          options={Scope_Damage_Index_config}
          data={chartData}
          ref={chartRef}
        />
      </BoxCharts>
    </>
  );
}

export default ScopeDamageIndex;
